import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { GetOwnerInformationQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQuery.type';
import { getOwnerInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getOwnerInformationQueryOptions = (
  params: GetOwnerInformationQueryParamsType,
) =>
  queryOptions({
    queryKey: ['CulpritOwnerInformation', params],
    queryFn: () => getOwnerInformationFunction(params),
    select: (data) => {
      return {
        ...data,
        personal_information: {
          ...data.personal_information,
          birthdate: convertTimestampToShamsi(
            data.personal_information.birthdate,
          ),
          gender: {
            label: data?.personal_information?.gender?.fa_const,
            value: data?.personal_information?.gender?.const,
          },
          owner_type: {
            label: data?.personal_information?.owner_type?.fa_const,
            value: data?.personal_information?.owner_type?.const,
          },
        },
      };
    },
  });
